import firebase from "firebase";
import axios from "axios";

const newUrl = function (url) {
  const dimensions = "500x500";
  const extIndex = url.lastIndexOf(".");
  const ext = url.substring(extIndex);
  return `${url.substring(0, extIndex)}_${dimensions}${ext}`;
};

export default {
  state: {
    images: [],
    percentageUploaded: 0,
    imageObj: {},
    fileIsReady: false,
  },
  getters: {
    images: (state) => state.images.sort((a, b) => a.sortOrder - b.sortOrder),
    imageObj: (state) => state.imageObj,
    fileIsReady: (state) => state.fileIsReady,
  },
  mutations: {
    setImages(state, payload) {
      state.images = payload;
    },
    setImageObj(state, payload) {
      state.imageObj = payload;
    },
    setPercentageUploaded(state, payload) {
      state.percentageUploaded = payload;
    },
    setFileIsReady(state, payload) {
      state.fileIsReady = payload;
    },
  },
  actions: {
    deleteImageDocument(context, payload) {
      //console.log"image obj to delete: ", payload)
      const propertyId = context.rootGetters.propertyId;
      const imageDocumentsRef = firebase
        .firestore()
        .collection("properties")
        .doc(propertyId)
        .collection("images");
      imageDocumentsRef
        .doc(payload.DOCID)
        .delete()
        .then(() => console.log("image deleted: ", payload.DOCID))
        .then(() => context.dispatch("deleteImage", payload))
        .catch((err) => console.log(err));
    },
    deleteImage(context, imageObj) {
      //console.log"deleteImage: ", imageObj)
      let fileName = imageObj.fileName;
      //console.logfileName)
      let storageRef = firebase.storage().ref(`/images/${fileName}`);
      storageRef
        .delete()
        .then(() => context.dispatch("getImages"))
        .catch((err) => console.log(err));
    },
    isFileReady(context, fileUrl) {
      axios
        .get(newUrl(fileUrl))
        .then(() => context.commit("setFileIsReady", true))
        .catch(() => context.commit("setFileIsReady", false));
    },
    storeImage({ commit, dispatch }, payload) {
      //console.log"storeImage Payload: ", payload)
      commit("setLoading", true);
      let propertyRef = firebase
        .firestore()
        .collection("properties")
        .doc(payload.propertyId);
      let propertyImagesRef = propertyRef.collection("images");
      let storageRef = firebase.storage().ref("/images/" + payload.fileName);
      // //console.logdatabaseRef)
      let thisDatabaseRef = "";
      if (payload.file) {
        payload.fileName = payload.file.name;
        const userId = firebase.auth().currentUser?.uid || null;
        const metadata = {
          customMetadata: {
            uploadedBy: userId,
            uploadedAt: new Date().toISOString(),
            propertyId: payload.propertyId,
          },
        };
        let task = storageRef.put(payload.file, metadata);
        task.on(
          "state_changed",
          function progess(snapshot) {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            commit("setPercentageUploaded", percentage);
          },
          function error(err) {},
          function complete() {}
        );
        task.then((snapshot) => {
          snapshot.ref
            .getDownloadURL()
            .then((url) => {
              payload.fileUrl = newUrl(url);

              //console.log"then: ",url)
            })
            .then(() => {
              payload.file = null;
              payload.base64 = null;
              payload.fileName = newUrl(payload.fileName);
              propertyImagesRef
                .doc()
                .set(payload, { merge: true })
                .then(() => {
                  //console.log"property image record created")
                  commit("setImageObj", payload);
                  dispatch("getImages");
                })
                .catch((err) => console.log(err));
            })
            .then(() => {
              if (payload.isAvatarImg) {
                let obj = { avatarImg: payload.fileUrl };
                propertyRef.set(obj, { merge: true });
              }
            })
            .then(function () {
              commit("setLoading", false);
            })
            .catch((error) => {
              console.log(error);
            });
        });
      } else {
        propertyImagesRef.add(payload).catch((error) => {
          console.log(error);
        });
      }
      commit("setLoading", false);
    },
    getImages(context) {
      let propertyId = context.rootGetters.propertyId;
      //console.log"Property Id: ", propertyId)
      let imagesArray = [];
      let propertiesRef = firebase.firestore().collection("properties");
      let imagesRef = propertiesRef.doc(propertyId).collection("images");
      imagesRef
        .get()
        .then((docs) => {
          if (docs.size) {
            docs.forEach((doc) => {
              let obj = doc.data();
              if (!obj.DELETED) {
                obj.KEY = doc.id;
                obj.DOCID = doc.id;
                imagesArray.push(obj);
              }
            });
            // console.log("resourceArray.length: ", resourceArray.length)
            context.commit("setImages", imagesArray);
          }
        })
        .catch((error) => {
          console.log("Error getting images:", error);
        });
    },
  },
};
